import { DivineControlEvent } from "../../DivineControlEventBase.js";
export class DCBaseKeyEvent extends DivineControlEvent {
    eventType = "keyboard-down";
    inputType = "keyboard";
    constructor() {
        super();
    }
    getKey() {
        return this.getData().key;
    }
}
